var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import {MuiThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import {logger, customBodyForExcelReport,handleExport,checkAuthentication,muiLoaderOptions} from '../../utils';
import FormControlLabel from '@mui/material/FormControlLabel';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import { createTheme, ThemeProvider } from "@mui/material/styles";

const ExcelJS = require('exceljs');

const pageStyles = makeStyles(theme => ({
    error: {
        "& .MuiSvgIcon-root": {
            color: '#c40018 !important',
            fill: '#c40018 !important',
        },
    },
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .MuiSvgIcon-root": {
            color: '#ffffff',
            fill: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiCheckbox - colorPrimary": {
            color: '#ffffff'
        },
    }
}));

const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 16px',
            position: 'sticky',
            top: 0,
            backgroundColor: '#fff',
            zIndex: 130,
            borderBottom: '1px solid #e0e0e0',
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          root: {
            position: 'sticky',
            top: 56, // match toolbar height
            backgroundColor: '#fff',
            zIndex: 120,
          },
        },
      },
    },
  });

export default function UserRolesReport(props) {
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [expand, setExpand] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [InactiveUsers, SetInactiveUsers] = React.useState(false);
	const [fullScreen, setFullScreen] = React.useState(false);
    const classes = pageStyles();

    const getUserRoles = async () => {
        await fetch('api/Reports/UserRoles', {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setDataSet(json));
        logger(dataSet);
    };


  
    const columns = [
        {
            name: "FirstName",
            label: "First Name",
            options: {
                filter: false,
                sort: true,
               //    position: "sticky",
            }
        },
        {
            name: "LastName",
            label: "Last Name",
            options: {
                filter: true,
                sort: true,
               //    position: "sticky",
            }
        },
        {
            name: "DefaultRole",
            label: "Default Role",
            options: {
                filter: true,
                sort: true,
				customBodyRenderLite: (dataIndex, rowIndex) => {
					var defaultRole = dataSet[dataIndex].DefaultRole;
					var defaultPositionStatus = dataSet[dataIndex].DefaultPositionStatus;
					var defaultPositionName = dataSet[dataIndex].DefaultPositionName;
					var defaultRoleStatus = dataSet[dataIndex].DefaultRoleStatus;

					if (moment(dataSet[dataIndex].EndDate).isSameOrBefore(moment(new Date()))) {
						return (
							<Tooltip title={`Default Role:${defaultRole} has expired`} placement="top-end">
								<div style={{ color: "red" }}>
									{defaultRole}
								</div>
							</Tooltip>
						);
					} else if (defaultPositionStatus === 0) {
						return (
							<Tooltip title={`Position:${defaultPositionName} is Inactive`} placement="top-end">
								<div style={{ color: "red" }}>
									{defaultRole}
								</div>
							</Tooltip>
						);
					} else if (defaultRoleStatus === 0) {
						return (
							<Tooltip title={`Default Role:${defaultRole} is Inactive`} placement="top-end">
								<div style={{ color: "red" }}>
									{defaultRole}
								</div>
							</Tooltip>
						);
					} else {
						return (
							<Tooltip>
								<div>
									{defaultRole}
								</div>
							</Tooltip>
						);
					}
				}
            }
        },
        {
            name: "Lab",
            label: "Lab",
            options: {
                filter: true,
                sort: true,
               //    position: "sticky",
            }
        },
        {
            name: "Position",
            label: "Position",
            options: {
                filter: true,
                sort: true,
                filterOptions: {
                    renderValue: val => {
                        if (val === "" || val === null || val === undefined) {
                            return "Not Set";
                        }
                        return val;
                    }
                },
                customBodyRender: (value) => {
                    //      logger(`value`, value)
                    if (value)
                        return (
                            <>{value}</>
                        );
                    else
                        return (
                            <div className={classes.error}>
                            <Tooltip title='No Role Defined' >
                                <ReportGmailerrorredIcon color="error" className={classes.error} />
                                </Tooltip>
                            </div>
                        );
                }
               //    position: "sticky",
            }
        },
        {
            name: "StartDate",
            label: "Effective Date",
            options: {
                filter: false,
                sort: true,
               //    position: "sticky",
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(dataSet[dataIndex].StartDate).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "EndDate",
            label: "End Date",
            options: {
                filter: false,
                sort: true,
               //    position: "sticky",
                customBodyRenderLite: (dataIndex, rowIndex) => {
					var defaultRole = dataSet[dataIndex].DefaultRole;
                    return (
                        <Tooltip title={moment(dataSet[dataIndex].EndDate).isSameOrBefore(moment(new Date())) ? `DefaultRole:${defaultRole} has expired`: ""} placement="top-end">
							<div style={moment(dataSet[dataIndex].EndDate).isSameOrBefore(moment(new Date())) ? { color: "red" } : {}}>
								{moment.utc(dataSet[dataIndex].EndDate).format("MM/DD/YYYY")}
							</div>
						</Tooltip>
                    );
                }
            }
        },
        {
            name: "IsActive",
            label: "Status",
            options: {
                filter: true,
                sort: true,
                display: false,
                filterList: ['Active']
            }
        }

    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }
    
	const handleMinimize = () => {
		setFullScreen(false);
	};
	
	const handleMaximize = () => {
	setFullScreen(true);
	};
	
    const initialRowsPerPage = getSavedRowsPerPage();

    const baseOptions = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        fixedHeader: true,
        fixedSelectColumn: false,
        responsive: 'standard',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
        onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);
				for (var i = 0; i < dataSet.length; i++) {
					var eachRow = data[i].data;
					eachRow[5] =  moment.utc(eachRow[5]).format("MM/DD/YYYY")
					eachRow[6] =  moment.utc(eachRow[6]).format("MM/DD/YYYY")
				}
				return customBodyForExcelReport({data:data, headers:headers});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename: 'UserRoles.xlsx'});
			return false;
		}

};

	var options = {};
	if (!fullScreen) {
		options = {
			...baseOptions,
			tableBodyHeight: "420px",
			tableBodyMaxHeight: "1000px",
			responsive: 'standard',
		}
	} else {
		options = {
			...baseOptions,
			responsive: 'standard',
			tableBodyHeight: "6750px",
			tableBodyMaxHeight: "82vh",
			rowsPerPage: initialRowsPerPage,
			selectableRows: 'none',
		}
	}

	const handleClickOpen = () => {

		setRefresh(true)
		setOpen(true);
        SetInactiveUsers(false);
    };

	const convertDates = (json) => {
		/*json.forEach(eachObj => {
			if (eachObj.StartDate) {
				eachObj.StartDate = moment.utc(eachObj.StartDate).format("MM/DD/YYYY");
			}
			if (eachObj.EndDate) {
				eachObj.EndDate = moment.utc(eachObj.EndDate).format("MM/DD/YYYY");
			}
		});*/
		setDataSet(json);
	};
	
    const handleClose = () => {
        setOpen(false);
        setExpand(true);
        setFullScreen(false);
    };
    React.useEffect(() => {
		checkAuthentication();
        //if (refresh) {
        //    logger ("expand-" ,expand)
            fetch(`api/Reports/UserRoles/${InactiveUsers}`)
                .then(res => res.json())
                .then(json => {
					convertDates(json);
					setIsLoading(false);
				})

        //    logger(dataSet);
            //setRefresh(false);
        //}

    }, [InactiveUsers])

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        
        <div>
            {logger(`data on return`, dataSet)}
            <Button variant="contained" onClick={handleClickOpen}>
                User Roles Report
            </Button>
            <MuiThemeProvider theme={muiThemeDesign}>
                <Dialog
							open={open}
							onClose={handleClose}
							fullScreen={fullScreen}
							fullWidth
							maxWidth={fullScreen ? false : 'xl'}
							scroll="paper"
							PaperProps={{
								style: {
									height: fullScreen ? '100vh' : '70vh',
									margin: fullScreen ? 0 : '5vh auto',
									borderRadius: fullScreen ? 0 : 10,
									overflow: 'hidden',
									display: 'flex',
									flexDirection: 'column',
								}
							}}
						>
						<DialogContent
							sx={{
								p: 0,
								flex: 1,
								display: 'flex',
								flexDirection: 'column',
								overflow: 'hidden',
							}}>
							<Box
								sx={{
									flex: 1,
									overflowY: 'auto',
									overflowX: 'hidden',
									position: 'relative', // ✨ important for sticky to work
								}}>
								<ThemeProvider theme={getMuiTheme()}>
									<MUIDataTable 
										title={
											<Box>
												<Typography variant="h6" style={{ color: "white" }}>
													<IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close"> <CloseIcon /> </IconButton>
													<Tooltip title={fullScreen ? 'Minimize' : 'Maximize'}>
														<IconButton
															color="inherit"
															onClick={fullScreen ? handleMinimize : handleMaximize}
														>
															{fullScreen ? <CloseFullscreenIcon /> : <FullscreenIcon />}
														</IconButton>
													</Tooltip>
													Beyondsoft Employee List
												</Typography>
											</Box>
										}
										data={isLoading ? [] : dataSet}
										columns={columns}
										options={muiLoaderOptions(options, isLoading)}
									/>
								</ThemeProvider>
                            </Box>
                        </DialogContent>
                    </Dialog>
            </MuiThemeProvider>
        </div>
    );
}
